export enum MessageType {
  EMPLOYEE_STATUS = 'employee-status',
  MESSAGE = 'message',
  UPDATE = 'update',
  DELETE = 'delete',
  CHANNEL_INIT = 'channel-init',
  CHANNEL_UPDATE = 'channel-update',
  CHANNEL_DELETE = 'channel-delete',
  UNREAD = 'unread',
  FILE_UPLOAD = 'file-upload',
  TYPING = 'typing',
  VIEWED = 'viewed',
}
